import { render, staticRenderFns } from "./SearchBox.vue?vue&type=template&id=3237416c&scoped=true&"
import script from "./SearchBox.vue?vue&type=script&lang=js&"
export * from "./SearchBox.vue?vue&type=script&lang=js&"
import style0 from "./SearchBox.vue?vue&type=style&index=0&id=3237416c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3237416c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\uat\\platform-uat\\Platform-foundation-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3237416c')) {
      api.createRecord('3237416c', component.options)
    } else {
      api.reload('3237416c', component.options)
    }
    module.hot.accept("./SearchBox.vue?vue&type=template&id=3237416c&scoped=true&", function () {
      api.rerender('3237416c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Search/SearchBox.vue"
export default component.exports